import React from "react";
// Import from the antd root so the component sees the app's ConfigProvider theme;
// the antd/lib deep import is a separate module instance and renders unthemed.
import {Typography} from "antd";
import {useTranslation} from "react-i18next";

const {Text} = Typography;

export default ({pagination}) => {
    const {t} = useTranslation();

    return (
        <>
            {pagination.total &&
                <Text type={'secondary'} style={{marginRight:'.5em', marginLeft: 'auto'}}>
                    <em>
                        {pagination.total} {pagination.total != 1 ? t('total-results','Total Results') : t('total-result','Total Result')}
                    </em>
                </Text>
            }
        </>
    )
}